/**
 * Main brand logo — place file in `public/` (e.g. `true-play-1.png` or `true play-1.png`).
 * Update only here when swapping the site logo.
 */
export const BRAND_LOGO_URL = '/true-play-1.png';
